import { TowerEvents } from "@/tower/tower-events";

export type DungeonBattleSurrenderOptions = {
  isBattleActive: () => boolean;
  confirmMessage: string;
  /** When set, runs instead of dispatching {@link TowerEvents.BattleGiveUp}. */
  onConfirm?: () => void;
  onSurrender?: () => void;
};

export function dungeonBattleSurrenderMarkup(): string {
  return `<button
    type="button"
    class="dungeon-battle-surrender"
    id="dungeon-battle-surrender"
    hidden
    title="ยอมแพ้และออกจากด่าน"
  >ยอมแพ้</button>`;
}

export function bindDungeonBattleSurrender(
  root: ParentNode,
  options: DungeonBattleSurrenderOptions,
): { unbind: () => void; sync: () => void } {
  let host = root.querySelector<HTMLButtonElement>("#dungeon-battle-surrender");
  if (!host) {
    const wrap = document.createElement("div");
    wrap.className = "dungeon-battle-surrender-host";
    wrap.innerHTML = dungeonBattleSurrenderMarkup();
    root.appendChild(wrap);
    host = wrap.querySelector<HTMLButtonElement>("#dungeon-battle-surrender");
  }

  const sync = () => {
    if (!host) return;
    const active = options.isBattleActive();
    host.hidden = !active;
    host.disabled = !active;
  };

  const onClick = () => {
    if (!options.isBattleActive()) return;
    if (!window.confirm(options.confirmMessage)) return;
    if (options.onConfirm) {
      options.onConfirm();
    } else {
      window.dispatchEvent(new CustomEvent(TowerEvents.BattleGiveUp));
    }
    options.onSurrender?.();
  };

  host?.addEventListener("click", onClick);
  sync();

  const unbind = () => {
    host?.removeEventListener("click", onClick);
    root.querySelector(".dungeon-battle-surrender-host")?.remove();
  };

  return { unbind, sync };
}
